import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { HeightMeasurement, HeightMeasurementsFetchParams } from '~/interfaces/babyGrowth'
import { fetchBabyGrowthHeightMeasurements, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'babyGrowthHeightMeasurements'

export const useFetchBabyGrowthHeightMeasurements = (
  params: HeightMeasurementsFetchParams
): UseQueryResult<HeightMeasurement[], Error> => {
  const fetcher = async (): Promise<HeightMeasurement[]> => {
    try {
      return await fetchBabyGrowthHeightMeasurements(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = (): boolean => hasObjectValue({ params })

  return useQuery<HeightMeasurement[], Error>([UNIQUE_KEY, params], async () => await fetcher(), {
    enabled: hasParams(),
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
